








































































































































































import {Component, Vue} from 'vue-property-decorator';
import firebase from 'firebase/app';
import 'firebase/storage';
import 'firebase/auth';
import 'firebase/firestore';
import uuid from 'uuid';
import htmlToImage from 'html-to-image';
import {Content, logout} from '@/api';
import AdComponent from '@/components/AdComponent.vue';


@Component({
    components: {
        ad: AdComponent,
    },
})
export default class RegisterView extends Vue {
    private imageURL: string | null = null;
    private inputText: string = '';
    private book: Content | null = null;

    private fontItems = [
        {text: 'デフォルト', value: {font_google: true}},
        {text: 'ふい字', value: {font_fui: true}},
        {text: 'たぬき油性マジック', value: {font_tanuki: true}},
    ];
    private selectFont = this.fontItems[0];
    private alert: boolean = false;
    private message = '';
    private isLoading: boolean = false;
    private invisible: boolean = false;
    private wordLen: number = 120;

    private fontSizeItems = [
        {text: 'デフォルト', value: {font_size: false}},
        {text: '10px', value: {f_sm: true}},
        {text: '20px', value: {f_md: true}},
        {text: '30px', value: {f_lg: true}},
        {text: '40px', value: {f_xl: true}},
        {text: '50px', value: {f_xxl: true}},
    ];
    private selectFontSize = this.fontSizeItems[0];

    private mounted() {
        window.scrollTo(0, 0);
        this.book = this.$store.getters.getBook;
        if (this.book === null) {
            this.$router.push({name: 'book_add'});
        }
    }

    private imageToDataUri(srcImg: CanvasImageSource, width: number, height: number): string {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d') as CanvasRenderingContext2D;
        canvas.width = width;
        canvas.height = height;

        ctx.drawImage(srcImg, 0, 0, width, height);
        return canvas.toDataURL('image/png', 1);
    }

    private loadImage(src: string): Promise<CanvasImageSource> {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => resolve(img);
            img.onerror = (e) => reject(e);
            img.src = src;
        });
    }

    private preview() {
        const q = document.getElementById('capture') as HTMLElement;
        htmlToImage.toPng(q, {quality: 1})
            .then((dataUrl) => {
                return this.loadImage(dataUrl);
            })
            .then((img) => {
                this.imageURL = this.imageToDataUri(img, 600, 314);
            })
            .catch((err) => {
                console.log(err);
            });
    }

    private share() {
        this.isLoading = true;
        const id = uuid.v4().toString();
        const user = firebase.auth().currentUser;
        const imageName = `${id}.png`;
        const q = document.getElementById('capture') as HTMLElement;

        // JSTの取得
        const now = firebase.firestore.FieldValue.serverTimestamp();

        if (this.book === null) {
            this.$router.push({name: 'book_add'});
        }
        if (user === null) {
            logout();
        }
        if (user != null && this.book != null) {
            this.alert = false;
            const book = this.book;
            const storageRef = firebase.storage().ref();
            const imagesRef = storageRef.child(`images/${imageName}`);
            const uid = user.uid;
            // console.log('u:,', uid);
            // htmlToImage.toPng(q, {width: 600, height: 314})
            htmlToImage.toPng(q, {quality: 1})
                .then((dataUrl) => {
                    return this.loadImage(dataUrl);
                })
                .then((img) => {
                    this.imageURL = this.imageToDataUri(img, 600, 314);
                    // 画像保存
                    return imagesRef.putString(this.imageURL.split(',')[1], 'base64', {contentType: 'image/png'});
                })
                .then((res) => {
                    return res.ref.getDownloadURL();
                })
                .then((url: string) => {
                    // DB書き込み
                    const ref = firebase.firestore().collection('impressions');
                    return ref.doc(id).set({
                        id,
                        user: uid,
                        image_url: url,
                        isbn: book.isbn,
                        book_title: book.title,
                        book_author: book.author,
                        book_publisher: book.publisherName,
                        book_affiliate_url: book.affiliateUrl,
                        book_thumb_img: book.mediumImageUrl,
                        created_at: now,
                        good: 0,
                        invisible: this.invisible,
                    });
                })
                .then((res) => {
                    this.isLoading = false;
                    console.log('success');
                    this.$router.push({name: 'imp_list'});
                })
                .catch((err) => {
                    console.log(err);
                    this.isLoading = false;
                    this.alert = true;
                    this.message = 'エラーが発生しました。もう一度お試しください。';
                });
        }
    }

    private ableShare(): boolean {
        return this.inputText.length <= this.wordLen && this.inputText.length > 0;
    }

    private reshapeString(st: string, len: number): string {
        if (st.length > len) {
            return st.slice(0, len) + '....';
        } else {
            return st;
        }
    }

    private fontResize() {
        if (this.selectFontSize.text === 'デフォルト') {
            if (this.inputText.length < 33) {
                return {font_xl: true};
            } else if (this.inputText.length < 56) {
                return {font_lg: true};
            } else if (this.inputText.length < 86) {
                return {font_md: true};
            } else if (this.inputText.length < 120) {
                return {font_sm: true};
            } else {
                return {font_sm: true};
            }
        } else {
            return this.selectFontSize.value;
        }
    }
}

